import styled from 'styled-components';

import { GenericDiv, GenericSpan } from 'commonStyles';

export const PriceText = styled(GenericSpan)`
	display: ${(props) => props.display ? props.display : 'inline'};
`;

export const IconWrapper = styled(GenericDiv)`
	display: inline-block; 
	vertical-align: text-top;
	text-align: center;
	height: 16px;
	cursor: pointer;
`;

IconWrapper.defaultProps = {
	f_weight: '900',
	color: '#008CFF',
	bg: '#E7F4FF',
	width: '16px',
	bdrRad: '50%',
	fsize: '12',
	left_M: '4'
};
